import axios from 'axios'
import store from '@/store'

// DEVELOPMENT
// const baseUrl = 'http://localhost:8080/api';
// const corsDomain = 'http://localhost:8080/';
const baseUrl = process.env.VUE_APP_API
// const baseUrl = 'http://localhost/nepDom/api';
// const corsDomain = 'http://localhost/nepDom/';
// PRODUCTION
// const baseUrl = 'https://nep-dom.si/api';
// const corsDomain = 'https://nep-dom.si/';

const AXIOS = axios.create({
  baseURL: baseUrl,
  timeout: 10000
});
export default {
    // hello() {
    // 	const auth = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain} }
    //   return AXIOS.get(`/hello`, auth);
    // },
    // getUser(userId) {
    // 	const auth = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain} }
    //   return AXIOS.get(`/auth/user/` + userId, auth);
    // },
    // createUser(firstName, lastName) {
    // 	const auth = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain} }
    //   return AXIOS.post(`/auth/user/` + firstName + '/' + lastName);
    // },
    executePostServerAction(action, data = null, auth = null, multipart = null) {
      // console.log('Action: ' + action)
      const authHeader = { }
      
      action = action + '.php'

      // let authHeader = { headers: { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain } } 
      // if (!auth && multipart){
      //   // console.log('  MULTIPART')
      //   authHeader.headers = { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain, 'Authorization': 'Bearer ' + store.getters.getToken }
      // }
      // if (auth && !multipart){
      //   // console.log('  AUTH')
      //   authHeader.headers = { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain, 'Authorization': 'Bearer ' + store.getters.getToken }
      // }
      // if (auth && multipart){
      //   // console.log('  AUTH + MULTIPART')
      //   authHeader.headers = { 'Accept': '*/*', 'Access-Control-Allow-Origin': corsDomain, 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + store.getters.getToken }
      // }
      if (!auth && multipart) {
        // console.log('  MULTIPART')
        authHeader.headers = { 'Content-Type': 'multipart/form-data' } // , 'Authorization': 'Bearer ' + store.getters.token }
      }
      if (auth && !multipart) {
        // console.log('  AUTH')
        authHeader.headers = { Authorization: 'Bearer ' + store.getters.token }
      }
      if (auth && multipart) {
        // if (multipart) {
        // console.log('  AUTH + MULTIPART')
        authHeader.headers = { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + store.getters.token }
      }
      return AXIOS.post(action, data, authHeader, { withCredentials: true });
    }
}
